<template>
	<div class="qrcode">
		<!-- 订单审核给测品仓时，弹框选择货品类型 -->
		<el-dialog
		  :title="$t('other.a650')"
		  :visible.sync="goodsVisable"
		  width="50%"
		  >
		      <!-- <el-radio-button label="陆运普货" v-for="(item,index) in goodsList" :key="index">{{item.goodsDesc}}</el-radio-button> -->
		      <el-radio v-model="goodsType" :label="item.goodsType" v-for="(item,index) in goodsList" :key="index">{{item.goodsDesc}}</el-radio>
	
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="goodsVisable = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="submitGoods">{{$t('other.a279')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 批量审核弹窗 -->
		<el-dialog
		  :title="$t('other.a651')"
		  :visible.sync="dialogVisible01Copy"
          @close="$emit('update:dialogVisible01',false)"
		  width="1200px"
		  >  
		   <div>
			<el-select  class="country-choose" @change="Review" v-model="value" :placeholder="$t('other.a653')">
		      <el-option
		        v-for="item in options"
		        :key="item.value"
		        :label="item.label"
		        :value="item.value">
		      </el-option>
		    </el-select>
			<span style="font-size:18px;color:#409EFF;margin-left:10px">{{$t('other.a655')}}：{{value == '' ?$t('other.a354')  :showStoreNameById(value)}}</span>
		   </div>
			<div style="text-align: center;margin: 10px; 0">{{$t('pendingorder.oop')}}</div>
			<div style="display: flex;justify-content: space-between;">
				<div>
					<div style="text-align: center;color: red;">{{$t('pendingorder.llo')}}：({{auditOrder_success.length}})</div>
					<div >
							<el-table
							     :data="auditOrder_success"
								 style="width: 500px;"
								 height="300"
							    >
							     <el-table-column
							       prop="ordersn"
							       :label="$t('pendingorder.ggo')"
							      >
							     </el-table-column>
								 <el-table-column
								   prop="shipByDate"
								   :label="$t('pendingorder.hho')"
								   :show-overflow-tooltip="true"
								   >
								   <template slot-scope="scope">
								   	<span>{{getTime(scope.row.shipByDate)}}</span>
								   </template>
								 </el-table-column>
							   </el-table>	  
					</div>
				</div>
				 <div>
					 <div style="text-align: center;color: red;">{{$t('pendingorder.pkl')}}：({{auditOrder_error.length}})</div>
					 <el-table
					      :data="auditOrder_error"
						   style="width: 500px;"
						  height="300"
					      >
					      <el-table-column
					        prop="ordersn"
					        :label="$t('pendingorder.ggo')"
							>
					      </el-table-column>
						
						  <el-table-column
						    prop="shipByDate"
						    :label="$t('pendingorder.hho')"
							:show-overflow-tooltip="true"
						    width="150">
						    <template slot-scope="scope">
						    	<span>{{getTime(scope.row.shipByDate)}}</span>
						    </template>
						  </el-table-column>
					    </el-table>
				 </div>
			</div>
		  <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="dialogVisible01Copy=false">{{$t('pendingorder.cancel')}}</el-button>
			<el-button type="primary" @click="revieworders(0)">{{$t('pendingorder.uuo')}}</el-button>
			<el-button type="primary" @click="revieworders(1)">{{$t('pendingorder.iio')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 自动审核弹窗 -->
		<el-dialog
		  :title="$t('pendingorder.Turn_on')"
		  :visible.sync="autoAudit"
		  @close="$emit('update:openAutoReview',false)"
		  width="70%"
		  >
		  <div >
			  <el-table
				   :data="autoReviesList"
				   style="width: 100%;">
			  	 <el-table-column
			  	   prop="shopName"
			  	   :label="$t('pendingorder.Store_Name')"
			  	   :show-overflow-tooltip="true"
					 width="150"
			  	   >
			  	 </el-table-column>
			  	 <el-table-column
			  	   :label="$t('pendingorder.warehouse')"
			  	   :show-overflow-tooltip="true"
			  	   width="200">
			  	  <template slot-scope="scope">
			  	   <el-select size="mini"  @change="checkWarehouseType(scope.row.storeId)" v-model="scope.row.storeId" :placeholder="$t('pendingorder.warehouse')">
			  	        <el-option
			  	          v-for="item in autoReviewWarehouse"
			  	          :key="item.value"
			  	          :label="item.label"
			  	          :value="item.value">
			  	        </el-option>
			  	      </el-select>
			  	   </template>
			  	 </el-table-column>
				 <el-table-column
				   :label="$t('pendingorder.un_include')"
				   :show-overflow-tooltip="true"
				   >
				  <template slot-scope="scope">
				   	<el-switch
				   	  v-model="scope.row.isVerify"
				   	  :active-text="$t('pendingorder.yes')"
				   	  :inactive-text="$t('pendingorder.no')">
				   	</el-switch>
				   </template>
				    <template  slot="header">
					<el-tooltip effect="light" :content="$t('other.a656')" placement="top">
						<span>{{$t('pendingorder.un_include')}} <i class="el-icon-question" style="font-size:22px"></i></span>
					</el-tooltip>
					</template>
				 </el-table-column>
				 <el-table-column
				   :label="$t('pendingorder.auto_distribute')"
				   :show-overflow-tooltip="true"
				   >
				  <template slot-scope="scope">
					<span v-if="!scope.row.ruleId && !scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;" @click="saveAutoRevies(scope.row)">{{$t('pendingorder.open')}}</span>
					<span v-if="scope.row.ruleId || scope.row.isOpen " style="color:#409EFF;margin:0 5px;cursor: pointer;" @click="saveAutoRevies(scope.row)">{{$t('pendingorder.Turned_on')}}</span>
					<span v-if="scope.row.ruleId || scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;" @click="closeAutoRevies(scope.row)">{{$t('pendingorder.shut_down')}}</span>
				   </template>
				 </el-table-column>
			     
			     </el-table>	
		  </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button type="primary" @click="autoAudit=false">{{$t('pendingorder.confirm')}}</el-button>
		  </span>
		</el-dialog>
		<!-- 设置手工单 -->
		<el-dialog
		  :title="$t('other.a241')"
		  :visible.sync="customerPop"
		  @close="$emit('update:showCustomerPop',false)"
		  width="80%"
		  >
		      <div class="customerPopBox">
				  <div style="text-align:right"><el-button  class="btn"  type="primary" @click="addProduct()">{{$t('other.a652')}}</el-button></div>
				  <el-table
					:data="list.items"
					height="450px"
					style="width: 100%">
					<el-table-column
						prop="date"
						:label="$t('other.a657')"
						width="60"
						>
						<template slot-scope="scope">
							<span class="pic">
								<img :src="scope.row.image" />
							</span>
						</template>
					</el-table-column>
					<el-table-column
						:label="$t('other.a179')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span class="pic">{{scope.row.itemName}}</span>
						</template>
					</el-table-column>
					<el-table-column
						prop="itemSku"
						:show-overflow-tooltip="true"
						label="itemSku">
						<template slot-scope="scope">
							<!-- <span v-show="isIndex !== scope.$index" >{{scope.row.itemSku}}</span> -->
							<el-input  size="small" v-model="scope.row.itemSku"></el-input>
						</template>
					</el-table-column>
					<el-table-column
						prop="var"
						:show-overflow-tooltip="true"
						label="variationSku">
						<template slot-scope="scope">
							<!-- <span v-show="isIndex !== scope.$index" >{{scope.row.variationSku}}</span> -->
							<!-- <el-input   size="small" v-model="scope.row.variationSku"></el-input> -->

							<el-select v-model="scope.row.variationId" :placeholder="scope.row.variations ? $t('other.a50') : $t('other.a658')" :disabled="!scope.row.variations">
								<el-option
								v-for="item in scope.row.variations"
								:key="item.variationId"
								:label="item.variationSku == '' ? $t('other.a260') :  item.variationSku"
								:value="item.variationId">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column
						prop="var"
						:show-overflow-tooltip="true"
						label="Qty">
						<template slot-scope="scope">
							
							<el-input  style="width:60px" size="small" v-model="scope.row.variationQuantityPurchased"></el-input>
						</template>
					</el-table-column>
					<el-table-column
						prop="sku"
						:label="$t('other.a33')">
						<template slot-scope="scope">
							<!-- <el-button v-show="isIndex !== scope.$index" size="mini" class="btn"  type="primary" @click="modify(scope.row,scope.$index)">{{$t('other.a93')}}</el-button> -->
							<el-button v-show="isIndex == scope.$index" size="mini" class="btn"  type="primary" @click="saveItem(scope.row,scope.$index)">{{$t('other.a216')}}</el-button>
							<el-button size="mini" class="btn"  type="primary" @click="deletItem(scope.row,scope.$index)">{{$t('other.a312')}}</el-button>
						</template>
					</el-table-column>
					</el-table>
			  </div>
			
				  
			
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="customerPop = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="saveOrderItem()">{{$t('other.a216')}}</el-button>
		  </span>
		</el-dialog>

		<!-- 添加商品 -->
		<el-dialog
		  :title="$t('other.a652')"
		  :visible.sync="showProList"
		  @close="$emit('update:showProListCopy',false)"
		  width="80%"
		  >
		      <div class="customerPopBox">
				  <div class="conditon">
					<el-select v-model="getDataList.storeId" @change="chooseStoreId()"  :placeholder="$t('other.a50')">
						<el-option
						v-for="item in storeOptions"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-select style="margin-left:10px" v-model="components"  :disabled='distrbute'   @change="changeType()" :placeholder="$t('other.a50')">
						<el-option
						v-for="item in productType"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-input style="width:250px;margin:0 10px" v-model="getDataList.cusCode" :placeholder="$t('other.a654')" clearable></el-input>
					<el-button type="primary" @click="getShopItems()">{{$t('other.a245')}}</el-button>
				  </div>
					<el-table
						ref="multipleTable"
						:data="warehouseItemList"
						tooltip-effect="dark"
						:row-key="row => row.groupId"
						style="width: 100%"
						height="350px"
						@selection-change="handleSelectionChangeMore">
						<el-table-column
						type="selection"
						:reserve-selection="true"
						width="55">
						</el-table-column>
						<el-table-column
						:label="$t('other.a66')"
						width="60">
						<template slot-scope="scope">
							<span class="pic">
								<img :src="scope.row.image" />
							</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a318')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span> {{scope.row.groupName}}</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a659')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span> {{scope.row.itemSku}}</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a660')"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<span> {{scope.row.storeItems.length}}</span>
						</template>
						</el-table-column>

						<el-table-column
						:label="$t('other.a661')"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<el-select v-model="scope.row.itemKey"  :placeholder="$t('other.a50')">
                                <el-option
                                v-for="item in scope.row.option"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
						</template>
						</el-table-column>
						
						
						
					</el-table>

					<div style="text-align:right">
				   	    <el-pagination
				   	    @size-change="handleSizeChange"
				   		@current-change="handleCurrentChange"
				   		:current-page="currentPage1"
				   		:page-sizes="[15, 20, 30, 50]"
				   		:page-size="20"
				   		layout="total, sizes, prev, pager, next, jumper"
				   		:total="total">
				   	    </el-pagination>
				   </div>
			  </div>
			  
			
				  
			
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="showProList = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="createProMore">{{$t('other.a216')}}</el-button>
		  </span>
		</el-dialog>

		<el-dialog
		  :title="$t('other.a652')"
		  :visible.sync="showMatch"
		  @close="$emit('update:showMatchCopy',false)"
		  width="80%"
		  >
		      <div class="customerPopBox">
				  <div class="conditon">
					<el-select v-model="getDataList.storeId" @change="chooseStoreId()"  :placeholder="$t('other.a50')">
						<el-option
						v-for="item in storeOptions"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-select style="margin-left:10px" v-model="components"  :disabled='distrbute'   @change="changeType()" :placeholder="$t('other.a50')">
						<el-option
						v-for="item in productType"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-input style="width:250px;margin:0 10px" v-model="getDataList.cusCode" :placeholder="$t('other.a654')" clearable></el-input>
					<el-button type="primary" @click="getShopItems()">{{$t('other.a245')}}</el-button>
				  </div>
					<el-table
						ref="multipleTable"
						:data="warehouseItemList"
						tooltip-effect="dark"
						:row-key="row => row.groupId"
						style="width: 100%"
						height="350px"
						@selection-change="handleSelectionChangeMore">
						<el-table-column
						type="selection"
						:reserve-selection="true"
						width="55">
						</el-table-column>
						<el-table-column
						:label="$t('other.a66')"
						width="60">
						<template slot-scope="scope">
							<span class="pic">
								<img :src="scope.row.image" />
							</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a318')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span> {{scope.row.groupName}}</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a659')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span> {{scope.row.itemSku}}</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a660')"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<span> {{scope.row.storeItems.length}}</span>
						</template>
						</el-table-column>

						<el-table-column
						:label="$t('other.a661')"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<el-select v-model="scope.row.itemKey" multiple :placeholder="$t('other.a50')" @change="selChange">
                                <el-option
                                v-for="item in scope.row.option"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
						</template>
						</el-table-column>
						
						
						
					</el-table>

					<div style="text-align:right">
				   	    <el-pagination
				   	    @size-change="handleSizeChange"
				   		@current-change="handleCurrentChange"
				   		:current-page="currentPage1"
				   		:page-sizes="[15, 20, 30, 50]"
				   		:page-size="20"
				   		layout="total, sizes, prev, pager, next, jumper"
				   		:total="total">
				   	    </el-pagination>
				   </div>
			  </div>
			  
			
				  
			
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="showMatch = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="createProMoreMatch">{{$t('other.a216')}}</el-button>
		  </span>
		</el-dialog>

		<!-- 绑定 -->
		<el-dialog
		  :title="textDesc"
		  :visible.sync="bindOrderCopy"
		  @close="$emit('update:bindOrder',false)"
		  width="80%"
		  >
		      <div class="customerPopBox">
				  <div class="conditon">
					<el-select v-if="bindOrderCopy" v-model="getDataList.storeId" @change="chooseStoreId()"  :placeholder="$t('other.a50')">
						<el-option
						v-for="item in storeOptions"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-select style="margin-left:10px" v-model="components"  :disabled='distrbute'   @change="changeType()" :placeholder="$t('other.a50')">
						<el-option
						v-for="item in productType"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-input style="width:250px;margin:0 10px" v-model="getDataList.cusCode" :placeholder="$t('other.a654')" clearable></el-input>
					<el-button type="primary" @click="getShopItems()">{{$t('other.a245')}}</el-button>
					<el-button type="primary" style="margin-left:20px;" @click="bindVirualSku">{{$t('other.a663')}}
					</el-button>
					<el-tooltip
          class="item"
          effect="dark"
          :content="$t('other.a662')"
          placement="top-start"
        >
          <i class="el-icon-question"></i>
        </el-tooltip>
				  </div>
					<el-table
						ref="multipleTable"
						:data="warehouseItemList"
						tooltip-effect="dark"
						style="width: 100%"
						height="350px"
						:tableKey="tableKey"
						@selection-change="handleSelectionChange">
						<el-table-column
						type="selection"
						width="55">
						</el-table-column>
						<el-table-column
						:label="$t('other.a66')"
						width="60">
						<template slot-scope="scope">
							<span class="pic">
								<img :src="scope.row.image" />
							</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a318')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span> {{scope.row.groupName}}</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a659')"
						:show-overflow-tooltip="true"
						width="180">
						<template slot-scope="scope">
							<span> {{scope.row.itemSku}}</span>
						</template>
						</el-table-column>
						<el-table-column
						:label="$t('other.a660')"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<span> {{scope.row.storeItems.length}}</span>
						</template>
						</el-table-column>

						<el-table-column
						:label="$t('other.a661')"
						:show-overflow-tooltip="true"
						>
						<template slot-scope="scope">
							<el-select v-model="scope.row.itemKey"  :placeholder="$t('other.a50')">
                                <el-option
                                v-for="item in scope.row.option"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
						</template>
						</el-table-column>
					</el-table>

					<div style="text-align:right">
				   	    <el-pagination
				   	    @size-change="handleSizeChange"
				   		@current-change="handleCurrentChange"
				   		:current-page="currentPage1"
				   		:page-sizes="[15, 20, 30, 50]"
				   		:page-size="20"
				   		layout="total, sizes, prev, pager, next, jumper"
				   		:total="total">
				   	    </el-pagination>
				   </div>
			  </div>	  
			
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="bindOrderCopy = false">{{$t('other.a106')}}</el-button>
		    <el-button type="primary" @click="createPro">{{$t('other.a216')}}</el-button>
		  </span>
		</el-dialog>

		
			  

	</div>
</template>

<script>

	import {mapState,mapActions,mapMutations} from 'vuex'
    import order from '../../../../api/moudles/order';
	import utils from '../../../../utils/utils'
	import userStoreItems from '../../../../api/moudles/userStoreItems'

	export default {
		name: "Dialog",
		data() {
			return {
				value:null,
                warehouselist:null,
				dialogVisible01Copy:false,
				options:null,
				goodsType:-1,
				storeOptions:[],
				goodsList:[],
				autoReviesList:[],
				bindOrderCopy:false,
				goodsVisable:false,
				distrbute:false,
				isVisualStore:false,
				isIndex:-1,
				autoAudit:false,
				customerPop:false,
				choseCategroyId:0,
				showProList:false,
				showMatch:false,
				currentPage1:1,
				chooseParams:null,
				list:[],
				selectedOptions2:[],
				multipleSelection:[],
				selectList:[],
				storeTypeCopy:-1,
				getDataList:{
					addition:false,
					component:true,
					cusCode:null,
					offset:20,
					page:0,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId,
					sellerId:JSON.parse(localStorage.getItem('userInfo')).userId,
					storeId:null,
					
				},
				productType:[{
					label:'单品/自营',
					value:1
				},{
					label:'套装/分销',
					value:2
				},{
					label:this.$t('other.a497'),
					value:3
				}],
				shopList:JSON.parse(localStorage.getItem('shopIdInfo')),
				warehouse:JSON.parse(localStorage.getItem('warehouse')),
				components:1,
				warehouseItemList:[],
				total:0,
				tableKey:0,
				mathList:[],
			};
		},

		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				auditOrder_success: state => state.order.auditOrder_success,
				auditOrder_error: state => state.order.auditOrder_error,
				autoReives: state => state.order.autoReives,
				cateGoryListCopy: state => state.mygoods.cateGoryListCopy,
				mygoodslist: state => state.mygoods.mygoodslist,
				goodsTotal:state => state.mygoods.goodsTotal,

		
			}),

			cusCodeCopy(){
				let ttp =this.getDataList.cusCode
				return ttp
			}

			
			


		},
		props: {
			dialogVisible01:{
				type: Boolean,
				default: false
			},
			warehouseValue:{
				type: Number,
				default: 0
			},
			textDesc:{
				type: String,
				default (){
					return this.$t('other.a664')
				}
			},
			openAutoReview:{
				type: Boolean,
				default: false
			},
			showCustomerPop:{
				type: Boolean,
				default: false
			},
			listData:{
				type: Array,
			},
			showProListCopy:{
				type: Boolean,
				default: false
			},
			bindOrder:{
				type: Boolean,
				default: false
			},
			showMatchCopy:{
				type: Boolean,
				default: false
			},
			mathListCopy:{
				type: Array,
				default (){
					return []
				}
			},

		},
		watch:{
			mathListCopy(){
				this.mathList=this.mathListCopy
			},
			showMatchCopy(){
				this.showMatch=this.showMatchCopy
				this.multipleSelection=[]
				this.warehouseItemList = []
				if(this.showMatchCopy){

					this.getStoreItemData()
				}
			},
			showProListCopy(){
				this.showProList=this.showProListCopy
				this.multipleSelection=[]
				if(this.showProListCopy){

					this.getStoreItemData()
				}
			},

			bindOrder(){
				this.bindOrderCopy=this.bindOrder
				this.multipleSelection=[]
				this.tableKey = new Date().getTime()
				if(this.bindOrderCopy){

					this.getStoreItemData()
				}
			},

			cusCodeCopy(){
				if(!this.cusCodeCopy){
					this.getStoreItem()
				}
			},

			
			dialogVisible01(){
				this.dialogVisible01Copy=this.dialogVisible01
			},
			warehouseValue(){
				this.value=this.warehouseValue
			},
			openAutoReview(){
				if(this.openAutoReview){
					this.getOpen()
				}
				this.autoAudit=this.openAutoReview
			},
			showCustomerPop	(){
				this.customerPop=this.showCustomerPop
			},
			listData(){
				this.list=this.listData
				
			},
			showProList(){
				if(!this.showProList){
					this.selectedOptions2=[]
					this.SET_SUCCESS_ERROR_NULL()
				}

				
			}

		},
		created() {
			this.init()
		},
		methods: {
			...mapActions('order', [
				'reviewOrderCopy',
				'getAutoreviewrules',
				'addAutoreviewrules',
				'delAutoreviewrules',
				'getVarationsById',
			]),

			...mapActions('mygoods', [
			'getShopAllItems',
			'addGoodsInStore',
			'getBindInfo',
			'tongBuShopee',
			'getLazadaWarehouseitems',
			'tongBuLazada',
			'getGoodsOrder',
			'getItemSales',
			'getInventoryTurnover',
			'getCategoryByshop',
			'batchCreateStoreItem'
			]),

			...mapMutations('mygoods', [
				'SET_SUCCESS_ERROR_NULL',
			]),
			...mapMutations('order', [
				'UPDATE_ALLORDERLIST',
			]),

			getStoreItemData(){
				this.storeOptions=utils.getAllwarehouse().slice(1)
					let faleStoreId=utils.getDefalultStoreId()
					
					let ttp=this.storeOptions.find(item => item.value == faleStoreId)
					
					if(ttp){
						this.getDataList.storeId=Number(utils.getDefalultStoreId())
					}else{
						this.getDataList.storeId=Number(this.storeOptions[0].value)
					}


					this.getDataList.component=true
					this.distrbute=false
					this.components=1
					let ccp=utils.isDistributionStroe(this.getDataList.storeId)
					console.log('ttp',ttp)
					if(ccp){
						this.components=2
						this.getDataList.component=false
						this.distrbute=true
					}
					
					console.log('getDataList',this.getDataList)
						
					this.getStoreItem()
			},

			getStoreItem(){
				userStoreItems
				.getStoreItem(this.getDataList)
				.then(res => {
					if(res.code === 200) {
						let arr = [];
						console.log('仓库产品的item',res.data)
						res.data.groups.forEach(p => {
							let status = false
							p.image=p.image ? p.image : p.storeItems[0].image
							p.itemSku=p.itemSku ? p.itemSku : this.$t('other.a260')
							p.itemKey=this.showMatch?[]:null
							if(this.multipleSelection&&this.multipleSelection.length!=0){
								for(let i =0;i<this.multipleSelection.length;i++){
									if(this.multipleSelection[i].groupId == p.groupId){
										p.itemKey = this.multipleSelection[i].itemKey
										break
									}
								}
							}
							p.groupName=p.groupName ? p.groupName : this.$t('other.a260')
							p.option=p.storeItems.map(v => {
								let str = v.variationName + '-' + v.cusCode + '-' + v.skuName
								// console.log(str)
								if(this.mathList.indexOf(str)!=-1){
									if(p.itemKey.indexOf('DXS|'+v.cusCode)==-1){
										p.itemKey.push('DXS|'+v.cusCode)
									}
									status = true
								}
								return {
									label:v.skuName,
									value:'DXS|'+v.cusCode,
									variationName:v.variationName
								}
							})
							if(status){
								arr.push(p)
							}
						})
						if(this.showMatch){
							this.$refs.multipleTable.clearSelection();
							this.toggleSelection(arr)
						}
						this.warehouseItemList=res.data.groups
						this.total=res.data.count
					}else{
						this.$message.warning(res.msg)
					}
				})
			},

			chooseStoreId(){
				console.log(this.getDataList.storeId)
				this.getDataList.component=true
				this.distrbute=false
				this.components=1
				let ttp=utils.isDistributionStroe(this.getDataList.storeId)
				console.log('ttp',ttp)

				if(ttp){
					this.components=2
					this.getDataList.component=false
					this.distrbute=true
				}

				

				utils.setDefalultStoreId(this.getDataList.storeId)
				this.getStoreItem()
			},

			changeType(){
				if(this.components == 1){
					this.getDataList.component=true
					this.getDataList.addition=false
				}
				if(this.components == 2){
					this.getDataList.component=false
					this.getDataList.addition=false
				}

				if(this.components == 3){
					this.getDataList.component=true
					this.getDataList.addition=true
				}

				this.getStoreItem()
			},

			saveOrderItem(){
				console.log(this.list)
				this.list.items.forEach(p => {
					if(p.isNew){
						p.variationId=p.variationId ? p.variationId : 0
					    p.itemKey='SHOPEE'+ '|'+ p.itemId + '_' + p.variationId 
					}
					
					p.variationQuantityPurchased=Number(p.variationQuantityPurchased)
					if(p.variations){
						p.variations.forEach(k => {
						if(p.variationId == k.variationId){
							p.variationSku=k.variationSku
						}
					})
					}
					
				})
				let params={
					shopId:this.list.shopId,
					orderId:this.list.orderId,
					items:this.list.items,
					userId:this.userId

				}

				console.log('params',params)
				order
				.updateCustomer(params)
				.then(res => {
					if(res.code === 200){
						this.$message.success(this.$t('other.a665'))
						this.UPDATE_ALLORDERLIST(res.data)
						this.customerPop=false
					}else{
						this.$message.warning(res.msg)
					}
				})
			},

			bindVirualSku(){
				this.$emit('bindVirualSku',this.getDataList.storeId)
			},
			createProMoreMatch(){
				//图库匹配
				console.log(this.multipleSelection)
				console.log(this.warehouseItemList)
				if(!this.multipleSelection){
					this.$message.warning(this.$t('other.a666'))
					return 
				}
				let arr = []
				for(let i =0;i<this.multipleSelection.length;i++){
					if(this.multipleSelection[i].itemKey.length == 0){
						this.$message.warning(this.$t('other.a667'))
						return 
					}else{
						const newArray = this.multipleSelection[i].option.filter(item => this.multipleSelection[i].itemKey.indexOf(item.value) != -1);
						for(let j = 0;j<newArray.length;j++){
							arr.push({
								cusCode:newArray[j].value?newArray[j].value.split('DXS|')[1]:'',
								skuName:newArray[j].variationName,
								variationName:newArray[j].label,
								imageUrl:'',
								createUser:this.userId
							})
							
							if(i == this.multipleSelection.length-1&&j == newArray.length - 1){
								this.$emit('updataItem',arr)
								this.$refs.multipleTable.clearSelection()
								this.showMatch=false
							}
						}
					}
				}
			},
			createProMore(){
				//测试一下
				console.log(this.multipleSelection)
				if(!this.multipleSelection||this.multipleSelection.length == 0){
					this.$message.warning(this.$t('other.a666'))
					return 
				}
				let arr = []
				for(let i =0;i<this.multipleSelection.length;i++){

					if(!this.multipleSelection[i].itemKey){
						this.$message.warning(this.$t('other.a667'))
						return 
					}else{
				
						let newObj={}
						this.multipleSelection[i].cusCode=Number(this.multipleSelection[i].itemKey.slice(4))
						let obj=this.multipleSelection[i].storeItems.find(item => item.cusCode === this.multipleSelection[i].cusCode)
						console.log(obj)
						console.log(this.multipleSelection[i])
						newObj.variationsCopy=this.multipleSelection[i].option.map(item => {
							return {
								itemKey:item.value,
								variationSku:item.label,
								variationName:item.variationName,

							}
						})
						console.log(this.multipleSelection[i].groupName)
						newObj.image=obj.image
						newObj.itemName=this.multipleSelection[i].groupName
						newObj.itemSku=obj.itemSku
						newObj.variationSku=obj.skuName
						newObj.variationQuantityPurchased=1
						newObj.variationId=null
						newObj.itemKey='DXS|'+obj.cusCode
						newObj.packageHeight=obj.packageHeight
						newObj.packageLength=obj.packageLength
						newObj.packageWidth=obj.packageWidth
						newObj.weight=obj.weight
						newObj.orderId=null
						newObj.storeId=obj.storeId
						newObj.variationName=obj.variationName
						newObj.weight=obj.weight
						newObj.storeNum=obj.storeNum
						// this.$emit('updataItem',newObj)
						arr.push(newObj)
						console.log(arr)
						if(i == this.multipleSelection.length-1){
							this.$emit('updataItem',arr)
							this.showProList=false
							this.$refs.multipleTable.clearSelection()
						}
					}
				}

			},
			
			createPro(){
				if(!this.multipleSelection){
					this.$message.warning(this.$t('other.a666'))
					return 
				}

				if(!this.multipleSelection.itemKey){
					this.$message.warning(this.$t('other.a667'))
					return 
				}

				
				this.multipleSelection.cusCode=Number(this.multipleSelection.itemKey.slice(4))
				let obj=this.multipleSelection.storeItems.find(item => item.cusCode === this.multipleSelection.cusCode)
				console.log(obj)
				console.log(this.multipleSelection)
				let newObj={}
				newObj.variationsCopy=this.multipleSelection.option.map(item => {
					return {
						itemKey:item.value,
						variationSku:item.label,
						variationName:item.variationName,

					}
				})
				newObj.image=obj.image
				newObj.itemName=this.multipleSelection.groupName
				newObj.itemSku=obj.itemSku
				newObj.variationSku=obj.skuName
				newObj.variationQuantityPurchased=1
				newObj.variationId=null
				newObj.itemKey='DXS|'+obj.cusCode
				newObj.packageHeight=obj.packageHeight
				newObj.packageLength=obj.packageLength
				newObj.packageWidth=obj.packageWidth
				newObj.weight=obj.weight
				newObj.orderId=null
				newObj.storeId=obj.storeId
				newObj.variationName=obj.variationName
				newObj.weight=obj.weight
				newObj.storeNum=obj.storeNum
				this.$emit('updataItem',newObj)
				this.showProList=false

			},

			handleChange(value) {
				
				console.log('value',value)
				this.choseCategroyId=value[value.length-1];
				let categoryIds=[];
				this.cateGoryListCopy.forEach((p)=>{
				this.pushIds(p,categoryIds,false);
				})
				let arr=new Set([...categoryIds])
				let arr2=Array.from(arr)
				arr2.unshift(value[0])
				this.chooseParams=arr2
				this.getDataList.categoryIds=null,
				this.getDataList.shopIds=[this.list.shopId]
				this.getShopAllItems(this.getDataList)
				
				
			  
			},

			pushIds(category,ids,isVal){
					if(isVal){
						if(category.hasChildren){
							category.children.forEach((p)=>{
							this.pushIds(p,ids,true);
							})
						}else{
							ids.push(category.value)
						}
					}else{
						if(category.value==this.choseCategroyId){
							this.pushIds(category,ids,true);
						}else{
							if(category.hasChildren){
								category.children.forEach((p)=>{
								this.pushIds(p,ids,false);
								})
							}
						}
					}
				},

			getShopItems() {
				this.getDataList.page=0
				console.log(this.getDataList)
				this.getStoreItem()
				
			},

			getShopItemsInit(){
				this.getDataList.page=0
				this.getDataList.categoryIds=null
				this.getShopAllItems(this.getDataList)
				
			},

			addProduct(){
				console.log(this.list)
				this.selectedOptions2[0]=this.list.shopId
				this.showProList=true
				this.getCategoryByshop({shopId:this.list.shopId}).then(res => {
					if(res == 'success'){
						this.handleChange([this.list.shopId])
					}
				})
				console.log(this.cateGoryListCopy)
			},

			modify(item,index){
				console.log(item,index)
				this.isIndex=index
				item.checked=true
				this.list.items[index].checked=true
				console.log(this.list.items[index])
				
			},

			saveItem(item,index){
				console.log(item,index)
				this.isIndex=-1
			},

			deletItem(item,index){
				if(this.list.items.length == 1){
					this.$message.warning(this.$t('other.a668'))
					return
				}
				console.log(item,index)
				this.$confirm(this.$t('other.a669'), this.$t("other.a142"), {
					  confirmButtonText: this.$t('other.a145'),
					  cancelButtonText: this.$t('other.a146'),
					  type: 'warning'
					}).then(() => {
					  
					  this.list.items.splice(index,1)
					})
				
			},

			toggleSelection(rows) {
				if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
				} else {
				this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChangeMore(val) {
				console.log(val)
				this.selectList  = [];
				// this.multipleSelection = val[val.length -1];
				this.multipleSelection = val;
				this.selectList=val
				console.log('multipleSelection',this.multipleSelection)

			},
			selChange(){
				this.$nextTick(()=>{
					if(this.showMatch){
						let arr = []
						this.multipleSelection.forEach(v=>{
							v.storeItems.forEach(p=>{
								let str = p.variationName + '-' + p.cusCode + '-' + p.skuName
										if(v.itemKey.indexOf('DXS|'+p.cusCode)!=-1){
											arr.push(str)
										}
							})
						})
						this.mathList = arr;
						console.log(this.mathList)
					}
				})
			},
			 handleSelectionChange(val) {
				this.selectList  = [];
				if (val.length > 1) {
					this.$refs.multipleTable.clearSelection();
					this.$refs.multipleTable.toggleRowSelection(
						val[val.length - 1]
					)
				}
				this.multipleSelection = val[val.length -1];
				this.selectList=val

				console.log('multipleSelection',this.multipleSelection)

			},

	


			//控制每页显示订单条数
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.getDataList.offset=parseInt(`${val}`)
				this.handleCurrentChange()
			},
			//显示当前第几页
			handleCurrentChange(val) {
					this.currentPage1=parseInt(`${val}`) 
					this.getDataList.page=(parseInt(`${val}`) -1) * this.getDataList.offset
					this.getStoreItem(this.getDataList)
					
			},



		    init(){
				this.options=utils.getAllwarehouse()
				this.getAutoreviewrules({userId:this.userId})
			},

			getOpen(){
			
				let arr=[]
				this.shopList.forEach(p => {
					let params={
						shopId:p.shopId,
						shopName:p.shopName,
						isVerify:false,
						storeId:'',
						userId:this.userId,
						isOpen:false,
						ruleId:'',
						isService:false
					}
					arr.push(params)
					this.autoReviesList=arr
				})
				
				let mmp=this.warehouse.map(item => {
					return {
						value:item.storeId,
						label:item.storeName + "(" + item.userName + ")"
					}
				})
				
				
				mmp.unshift({
					value:'',
					label:this.$t('other.a140')
				})
				
				this.autoReviewWarehouse=mmp
				
				this.autoReives.forEach(p => {
					this.autoReviesList.forEach((k,index) => {
						if(p.shopId === k.shopId) {
							
							this.autoReviesList[index].isVerify = p.isVerify
							this.autoReviesList[index].storeId = p.storeId
							this.autoReviesList[index].userId = p.userId
							this.autoReviesList[index].ruleId = p.ruleId
							this.autoReviesList[index].isService = p.isService
							
						}
					})
				})
			},

			submitGoods(){
				console.log(this.goodsType)
				this.goodsVisable=false
			},
            revieworders(num){
				if(this.isVisualStore){
					if(this.goodsType == -1){
						this.$message.warning(this.$t('other.a670'))
						return 
					}
				}
				let arr=this.getList(this.auditOrder_success)
				let arr2=this.getList(this.auditOrder_error)
				console.log(arr)
				console.log(arr2)
				if(num == 0){
					this.reviewOrderCopy(arr).then(res => {
						if(res === 200){
							this.dialogVisible01Copy=false
						}
					})
					return
				}
				this.reviewOrderCopy([...arr,...arr2]).then(res => {
					if(res === 200){
						this.dialogVisible01Copy=false
					}
				})
			},
            cancelReview(){

            },
			checkWarehouseType(StoreId){
				this.warehouse.forEach(p => {
					if(p.storeId === StoreId){
						this.storeTypeCopy=p.storeType
					}
				})
				if(this.storeTypeCopy === 0) {
					this.$message.error(this.$t('other.a671'))
				}
			},
			saveAutoRevies(item){
				if(!item.storeId) {
					this.$message.error(this.$t('other.a672'))
					return
				}
				
				if(this.storeTypeCopy === 0) {
					this.$message.error(this.$t('other.a671'))
					return
				}
				
				this.autoReviesList.forEach(p => {
					if(p.shopId === item.shopId) {
						p.isOpen=true
					}
				})
				console.log(item)
				this.addAutoreviewrules(item)
				this.getAutoreviewrules({userId:this.userId})
			},
		
			closeAutoRevies(item){
				this.delAutoreviewrules(item)
				this.autoReviesList.forEach(p => {
					if(p.shopId === item.shopId) {
						p.isOpen=false
						p.ruleId=''
						p.storeId=''
						p.isVerify=false
						p.isService=false
						
					}
				})
				console.log(this.autoReviesList)
			},
            Review(){
				let warehouse=JSON.parse(localStorage.getItem('userInfo')).stores
				let list=warehouse.find(p => p.storeId == this.value)
				if(list.storeType ==0){
					this.goodsVisable=true
					this.isVisualStore=true
					this.goodsList=list.chargeRule.goodsChargeList
					return
				}
				this.goodsType=-1
				this.isVisualStore=false
				console.log('list',list)
            },
			showStoreNameById(id){
				return utils.showstoreNameBystoreId(id)

			},
			getTime(time){
				 return utils.renderTime(time)
			},
			getList(list){
			    return list.map(p => {
					return {
						goodsType:this.goodsType,
						ordersn:p.ordersn,
						shopId:p.shopId,
						storeId:this.value,
						service:p.service,
						userId:this.userId,
						platform:0
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
.pic{
	display: inline-block;
	width: 40px;
	height: 40px;


	img{
		width: 100%;
	}
}

/deep/ .el-checkbox__inner{
	border: 1px solid #000;
}




.el-table {
    thead {
      .el-table-column--selection {
        .cell {
          display: none;
        }
      }
   }
}

.customerPopBox{
	width: 100%;
	display: flex;
	height: 450px;
	flex-direction: column;

	.conditon{
		display: flex;
		margin:0 10px;
	}
}

.el-icon-question{
	    font-size: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

	margin-left: 10px;
}

// .btn{
// 	padding: 0 5px;
// }

</style>
